/**
 * BYOB Quick View
 * Layer 1: Inline expandable panel per product card
 * Layer 2: Bottom-sheet modal with carousel + full description
 */
(function(){

  /* ──────────────────────────────
     LAYER 2 — Full Description Modal
     ────────────────────────────── */
  var backdrop = document.getElementById('byobQvBackdrop');
  var modal = document.getElementById('byobQvModal');
  var modalTitle = document.getElementById('byobQvModalTitle');
  var modalTagline = document.getElementById('byobQvModalTagline');
  var modalSubtitle = document.getElementById('byobQvModalSubtitle');
  var modalCtaLabel = document.getElementById('byobQvModalCtaLabel');
  var modalPrice = document.getElementById('byobQvModalPrice');
  var modalReviews = document.getElementById('byobQvModalReviews');
  var modalBody = document.getElementById('byobQvModalBody');
  var modalScroll = document.getElementById('byobQvModalScroll');
  var modalContent = document.getElementById('byobQvModalContent');
  var modalCtaWrap = document.getElementById('byobQvModalCtaWrap');
  var carouselTrack = document.getElementById('byobQvCarouselTrack');
  var carouselDots = document.getElementById('byobQvCarouselDots');
  var desktopQuickViewMq = window.matchMedia('(min-width: 768px)');
  var modalCta = document.getElementById('byobQvModalCta');
  var currentModalVariantId = null;
  var carouselIdx = 0;
  var modalHalfStarStyleId = 'byobQvModalHalfStarStyle';
  var modalHideTimer = null;

  // Move modal + backdrop to document.body so position:fixed works correctly.
  // The .bundler-builder section has transform:translateX(-50%) which creates
  // a new containing block, breaking fixed positioning for descendants.
  if (backdrop) document.body.appendChild(backdrop);
  if (modal) document.body.appendChild(modal);
  if (backdrop) backdrop.hidden = true;
  if (modal) modal.hidden = true;

  function setIubendaModalOffset(isOpen) {
    var iubendaBtn = document.querySelector(
      '.iubenda-tp-btn.iubenda-cs-preferences-link'
    );
    if (!iubendaBtn) return;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isOpen && isMobile) {
      iubendaBtn.style.setProperty('bottom', '50px', 'important');
      iubendaBtn.style.setProperty('left', '40px', 'important');
      return;
    }

    iubendaBtn.style.removeProperty('bottom');
    iubendaBtn.style.removeProperty('left');
  }

  function openModal(gridItem) {
    if (!modal) return;
    if (modalHideTimer) {
      clearTimeout(modalHideTimer);
      modalHideTimer = null;
    }
    if (backdrop) backdrop.hidden = false;
    modal.hidden = false;

    var data = gridItem.querySelector('[data-byob-qv-product-data]');
    if (!data) return;

    currentModalVariantId = data.dataset.variantId;
    var productData = JSON.parse(data.textContent);
    var displayTitle = productData.title;
    if (typeof displayTitle === 'string' && displayTitle.indexOf('~') !== -1) {
      displayTitle = displayTitle.split('~')[0].trim();
    }

    modalTitle.textContent = '';
    if (productData.url) {
      var titleLink = document.createElement('a');
      titleLink.href = productData.url;
      titleLink.target = "_blank" 
      titleLink.textContent = displayTitle;
      modalTitle.appendChild(titleLink);
    } else {
      modalTitle.textContent = displayTitle + ' ↗';
    }
    if (modalTagline) modalTagline.textContent = productData.tagline || '';
    modalSubtitle.textContent =  '';
    modalPrice.textContent = productData.price;
    populateModalReviews(gridItem, productData.url);

    // Keep CTA outside modalBody before replacing body HTML.
    if (modalCta && modalCtaWrap && modalCta.parentNode !== modalCtaWrap) {
      modalCtaWrap.appendChild(modalCta);
    }

    // Build carousel
    carouselIdx = 0;
    carouselTrack.innerHTML = productData.images
      .map(function (img) {
        return '<div class="byob-qv-carousel__slide"><img src="' + img + '" alt="' + productData.title + '" loading="lazy"></div>';
      })
      .join('');

    carouselDots.innerHTML = productData.images
      .map(function (_, i) {
        return '<button class="byob-qv-dot' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '" aria-label="Slide ' + (i + 1) + '"></button>';
      })
      .join('');

    if (desktopQuickViewMq.matches || productData.images.length <= 1) {
      carouselDots.style.display = 'none';
    } else {
      carouselDots.style.display = '';
    }

    // Build body content
    var bodyHTML = '';

    if (productData.icons && productData.icons.length) {
      bodyHTML += '<div class="byob-qv-modal__icons">';
      productData.icons.forEach(function (icon) {
        bodyHTML += '<div class="byob-qv-modal__icon">';
        bodyHTML += '<img src="' + icon.src + '" alt="" width="' + icon.width + '" height="' + icon.height + '" loading="lazy">';
        bodyHTML += '<span>' + icon.text + '</span>';
        bodyHTML += '</div>';
      });
      bodyHTML += '</div>';
    }

    // Description above accordion
    if (productData.description) {
      bodyHTML += '<div class="byob-qv-modal__desc-section">';
      bodyHTML += '<div class="byob-qv-modal__desc">' + productData.description + '</div>';
      bodyHTML += '</div>';
    }

    // Accordion tabs (from PDP metafields: ingredients, how_to_use, benifits, tastes_like, why_kroma)
    if (productData.accordion && productData.accordion.length) {
      bodyHTML += '<div class="byob-qv-modal__accordion">';
      productData.accordion.forEach(function (tab) {
        bodyHTML += '<div class="byob-qv-modal__acc-item">';
        bodyHTML += '<button type="button" class="byob-qv-modal__acc-header" aria-expanded="false">';
        bodyHTML += '<span>' + tab.title + '</span>';
        bodyHTML += '<span class="byob-qv-modal__acc-icon">+</span>';
        bodyHTML += '</button>';
        bodyHTML += '<div class="byob-qv-modal__acc-body">';
        bodyHTML += '<div class="byob-qv-modal__acc-content">' + tab.content + '</div>';
        bodyHTML += '</div>';
        bodyHTML += '</div>';
      });
      bodyHTML += '</div>';
    }

    modalBody.innerHTML = bodyHTML;
    placeModalCtaInDescription();

    // Update CTA state
    refreshModalCta();

    modalScroll.scrollTop = 0;
    if (modalContent) modalContent.scrollTop = 0;
    if (modalBody) modalBody.scrollTop = 0;
    backdrop.classList.add('is-open');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    addHalfStarModalStyle();
    setIubendaModalOffset(true);
  }

  function closeModal() {
    if (!modal) return;
    backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    currentModalVariantId = null;
    removeHalfStarModalStyle();
    setIubendaModalOffset(false);
    if (modalHideTimer) clearTimeout(modalHideTimer);
    modalHideTimer = setTimeout(function () {
      if (backdrop) backdrop.hidden = true;
      modal.hidden = true;
      modalHideTimer = null;
    }, 420);
  }

  function addHalfStarModalStyle() {
    if (document.getElementById(modalHalfStarStyleId)) return;

    var styleEl = document.createElement('style');
    styleEl.id = modalHalfStarStyleId;
    styleEl.textContent =
      '.star-container.yotpo-sr-star-half stop:first-of-type {' +
      'stop-color: #fe591e !important;' +
      '}';

    document.head.appendChild(styleEl);
  }

  function removeHalfStarModalStyle() {
    var styleEl = document.getElementById(modalHalfStarStyleId);
    if (styleEl && styleEl.parentNode) {
      styleEl.parentNode.removeChild(styleEl);
    }
  }

  function populateModalReviews(gridItem, productUrl) {
    if (!modalReviews) return;

    modalReviews.innerHTML = '';
    var sourceReviews = gridItem.querySelector('.yotpo-widget-instance');
    if (!sourceReviews) return;

    var reviewsClone = sourceReviews.cloneNode(true);
    reviewsClone.classList.add('byob-qv-modal__reviews-widget');

    if (productUrl) {
      var reviewsLink = document.createElement('a');
      reviewsLink.href = productUrl;
      reviewsLink.target = '_blank';
      reviewsLink.rel = 'noopener noreferrer';
      reviewsLink.className = 'byob-qv-modal__reviews-link';
      reviewsLink.appendChild(reviewsClone);
      modalReviews.appendChild(reviewsLink);
      return;
    }

    modalReviews.appendChild(reviewsClone);
  }

  function placeModalCtaInDescription() {
    if (!modalCta || !modalBody) return;
    if (!desktopQuickViewMq.matches) return;

    var desc = modalBody.querySelector('.byob-qv-modal__desc');
    if (!desc) return;

    var inlineCta = document.createElement('div');
    inlineCta.className = 'byob-qv-modal__inline-cta';
    inlineCta.appendChild(modalCta);

    var firstUl = desc.querySelector('ul');
    if (firstUl) {
      firstUl.insertAdjacentElement('afterend', inlineCta);
      return;
    }

    var paragraphs = desc.querySelectorAll('p');
    if (paragraphs.length) {
      paragraphs[paragraphs.length - 1].insertAdjacentElement('afterend', inlineCta);
      return;
    }

    desc.appendChild(inlineCta);
  }

  function refreshModalCta() {
    if (!modalCta || !currentModalVariantId) return;

    var bundlerEl = document.querySelector('bundler-builder');
    var checkbox = bundlerEl
      ? bundlerEl.querySelector('input[type="checkbox"][value="' + currentModalVariantId + '"]')
      : null;
    var gridItem = checkbox ? checkbox.closest('.bundler-builder--grid-item') : null;
    var isSoldOut = gridItem && gridItem.querySelector('.bundler-button--sold-out');

    if (isSoldOut) {
      if (modalCtaLabel) modalCtaLabel.textContent = 'Sold Out';
      if (modalPrice) modalPrice.textContent = '';
      modalCta.className = 'byob-qv-modal__cta byob-qv-modal__cta--sold-out';
      modalCta.disabled = true;
      return;
    }

    var currentBundleSize = getBundleSize();
    if (currentBundleSize >= 5) {
      if (modalCtaLabel) modalCtaLabel.textContent = 'Bundle Full';
      if (modalPrice) modalPrice.textContent = '';
      modalCta.className = 'byob-qv-modal__cta byob-qv-modal__cta--sold-out';
      modalCta.disabled = true;
      return;
    }

    if (modalCtaLabel) modalCtaLabel.textContent = 'Add to Bundle -';
    modalCta.className = 'byob-qv-modal__cta byob-qv-modal__cta--add';
    modalCta.disabled = false;
  }

  function getBundleSize() {
    var navItems = document.querySelectorAll(
      '.bundler-builder--nav-item[data-nav-item-has-content="true"]'
    );
    return navItems.length;
  }

  function handleModalCtaClick() {
    if (!currentModalVariantId) return;
    if (getBundleSize() >= 5) {
      refreshModalCta();
      return;
    }

    var bundlerEl = document.querySelector('bundler-builder');
    if (!bundlerEl) return;

    var checkbox = bundlerEl.querySelector(
      'input[type="checkbox"][value="' + currentModalVariantId + '"]'
    );
    if (!checkbox) return;

    // Simulate the same behavior as clicking the Add to Bundle button
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('input', { bubbles: true }));

    closeModal();
  }

  /* Carousel navigation */
  function goToSlide(index) {
    if (!carouselTrack || desktopQuickViewMq.matches) return;
    carouselIdx = index;
    carouselTrack.scrollTo({
      left: index * carouselTrack.offsetWidth,
      behavior: 'smooth',
    });
    updateDots();
  }

  function updateDots() {
    if (!carouselDots) return;
    carouselDots.querySelectorAll('.byob-qv-dot').forEach(function (dot, j) {
      dot.classList.toggle('is-active', j === carouselIdx);
    });
  }

  function onCarouselScroll() {
    if (!carouselTrack || desktopQuickViewMq.matches) return;
    var newIdx = Math.round(carouselTrack.scrollLeft / carouselTrack.offsetWidth);
    if (newIdx !== carouselIdx) {
      carouselIdx = newIdx;
      updateDots();
    }
  }

  /* ──────────────────────────────
     Event Delegation
     ────────────────────────────── */
  // Capture-phase handler so Yotpo widgets can still trigger modal open
  // even when internal scripts stop event bubbling.
  document.addEventListener(
    'click',
    function (e) {
      var yotpoTrigger = e.target.closest(
        '.yotpo-reviews-star-ratings-widget .yotpo-widget-clear'
      );
      if (!yotpoTrigger) return;

      var gridItem = yotpoTrigger.closest('.bundler-builder--grid-item');
      if (!gridItem) return;

      e.preventDefault();
      e.stopPropagation();
      openModal(gridItem);
    },
    true
  );

  document.addEventListener('click', function (e) {
    // Open modal from "View full description" button
    var fullBtn = e.target.closest('[data-byob-qv-open-modal]');
    if (fullBtn) {
      e.preventDefault();
      var gridItem = fullBtn.closest('.bundler-builder--grid-item');
      if (gridItem) openModal(gridItem);
      return;
    }

    // Toggle inline quick view from anywhere on the card,
    // except explicit interactive controls.
    var gridItem = e.target.closest('.bundler-builder--grid-item');
    if (gridItem) {
      var interactiveTarget = e.target.closest(
        '#addBundleBtn, [data-byob-qv-open-modal], .byob-qv-panel__full-btn, input, button, a, select, textarea'
      );
      if (!interactiveTarget) {
        e.preventDefault();
        e.stopPropagation();
        openModal(gridItem);
        return;
      }
    }

    // Close modal
    if (e.target.closest('[data-byob-qv-close-modal]')) {
      closeModal();
      return;
    }

    // Modal CTA
    if (e.target.closest('#byobQvModalCta')) {
      handleModalCtaClick();
      return;
    }

    // Modal accordion toggle
    var accHeader = e.target.closest('.byob-qv-modal__acc-header');
    if (accHeader) {
      var accItem = accHeader.closest('.byob-qv-modal__acc-item');
      if (accItem) {
        var wasOpen = accItem.classList.contains('is-open');
        accItem.classList.toggle('is-open');
        accHeader.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
      }
      return;
    }

    // Carousel dots
    var dot = e.target.closest('.byob-qv-dot');
    if (dot && dot.dataset.slide !== undefined) {
      goToSlide(parseInt(dot.dataset.slide, 10));
      return;
    }

    // Backdrop click
    if (e.target.id === 'byobQvBackdrop') {
      closeModal();
      return;
    }
  });

  // Carousel scroll tracking
  if (carouselTrack) {
    carouselTrack.addEventListener('scroll', onCarouselScroll, { passive: true });
  }

  // Escape key closes modal
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();
